/* __next_internal_client_entry_do_not_use__ AlertBanner auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { renderTextAction } from "@faire/web--source/common/buttonUtils";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled, { useTheme } from "styled-components";
import { Close } from "../../slate/icons/foundation/Close";
import { getSpacing, Spacer } from "../../slate/spacing";
var Wrapper = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-16d3b319-0"
})([
    "background:",
    ";padding:",
    ";width:100%;position:relative;"
], function(props) {
    var _props_theme_banners_alert, _props_theme_banners;
    var _props_$color, _ref;
    return (_ref = (_props_$color = props.$color) !== null && _props_$color !== void 0 ? _props_$color : (_props_theme_banners = props.theme.banners) === null || _props_theme_banners === void 0 ? void 0 : (_props_theme_banners_alert = _props_theme_banners.alert) === null || _props_theme_banners_alert === void 0 ? void 0 : _props_theme_banners_alert.color) !== null && _ref !== void 0 ? _ref : Core.surface.warning;
}, getSpacing(12, "2x"));
var CloseButton = styled.button.withConfig({
    componentId: "sc-16d3b319-1"
})([
    "position:absolute;right:16px;display:flex;font-size:20px;"
]);
/**
 * @trackcomponent
 * @link [Docs](https://slate.faire.team/retailer/component/alert-banner)
 */ export var AlertBanner = function(param) {
    var color = param.color, onClose = param.onClose, textColor = param.textColor, message = param.message, alertAction = param.alertAction, className = param.className, centerAlignIcon = param.centerAlignIcon;
    var _theme_banners_alert, _theme_banners, _theme_banners_alert1, _theme_banners1;
    var theme = useTheme();
    var alertActionComponent = renderTextAction(alertAction, {
        textColor: textColor !== null && textColor !== void 0 ? textColor : theme === null || theme === void 0 ? void 0 : (_theme_banners = theme.banners) === null || _theme_banners === void 0 ? void 0 : (_theme_banners_alert = _theme_banners.alert) === null || _theme_banners_alert === void 0 ? void 0 : _theme_banners_alert.textColor
    });
    return /*#__PURE__*/ _jsxs(Wrapper, {
        $color: color,
        className: className,
        children: [
            typeof message === "string" ? /*#__PURE__*/ _jsxs(Row, {
                align: centerAlignIcon ? "center" : undefined,
                children: [
                    renderEventsIcon(theme),
                    /*#__PURE__*/ _jsxs(Typography, {
                        color: textColor !== null && textColor !== void 0 ? textColor : theme === null || theme === void 0 ? void 0 : (_theme_banners1 = theme.banners) === null || _theme_banners1 === void 0 ? void 0 : (_theme_banners_alert1 = _theme_banners1.alert) === null || _theme_banners_alert1 === void 0 ? void 0 : _theme_banners_alert1.textColor,
                        align: "center",
                        children: [
                            message,
                            alertActionComponent ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    " ",
                                    alertActionComponent
                                ]
                            }) : null
                        ]
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(Row, {
                align: centerAlignIcon ? "center" : undefined,
                children: [
                    renderEventsIcon(theme),
                    message,
                    alertActionComponent ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: 4
                            }),
                            alertActionComponent
                        ]
                    }) : null
                ]
            }),
            onClose ? /*#__PURE__*/ _jsx(CloseButton, {
                onClick: onClose,
                children: /*#__PURE__*/ _jsx(Close, {
                    fontSize: "16px"
                })
            }) : null
        ]
    });
};
var renderEventsIcon = function(theme) {
    if (!(theme === null || theme === void 0 ? void 0 : theme.eventIcon)) {
        return null;
    }
    var Component = theme.eventIcon.Component;
    return /*#__PURE__*/ _jsx(Component, {
        "data-test-id": "alert-banner-event-icon",
        width: "20px",
        height: "20px",
        margin: "0 8px 0 0"
    });
};
